export const PINNED_CELL = "sticky right-0 z-[1]";

export const PINNED_CELL_FADE =
  "before:pointer-events-none before:absolute before:inset-y-0 before:-left-9 before:w-9 before:bg-gradient-to-r before:from-transparent";
